export default __webpack_public_path__ + "static/media/icon_instagram.09e9f25a.svg";